import axios from 'axios'
import { Ban } from 'lucide-react'
import { useState } from 'react'
import { constants } from '../../Constants'
import { Button, Modal } from '../ui'
import { useToast } from '../ui/Toast/Toast'

export const AlertDialogCancelSubscription = ({ user, onCancelled }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const toast = useToast()

  if (!user?.hasPaid) return null

  const handleCancel = async () => {
    setLoading(true)
    try {
      const response = await axios.put(
        `${constants.urlLocal}changeSubscriptionStatus`,
        { userId: user._id, hasPaid: false }
      )
      if (response.data.ok) {
        toast({ title: 'Suscripción cancelada', status: 'success' })
        onCancelled?.(response.data.user)
        setIsOpen(false)
      } else {
        toast({
          title: 'Error al cancelar la suscripción',
          description: response.data.message,
          status: 'error',
        })
      }
    } catch (error) {
      toast({
        title: 'Error al cancelar la suscripción',
        description:
          error.response?.data?.message || 'Inténtalo de nuevo más tarde',
        status: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Button
        variant="danger"
        size="sm"
        icon={<Ban size={16} />}
        onClick={() => setIsOpen(true)}
      >
        Cancelar suscripción
      </Button>
      <Modal
        isOpen={isOpen}
        onClose={() => !loading && setIsOpen(false)}
        title="Cancelar suscripción"
        size="sm"
      >
        <p>
          ¿Seguro que quieres cancelar la suscripción de{' '}
          <strong>{user?.name || user?.email}</strong>? Pasará a estado "No
          pagado".
        </p>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '0.5rem',
            marginTop: '1.5rem',
          }}
        >
          <Button
            variant="ghost"
            onClick={() => setIsOpen(false)}
            disabled={loading}
          >
            Volver
          </Button>
          <Button variant="danger" onClick={handleCancel} loading={loading}>
            Sí, cancelar suscripción
          </Button>
        </div>
      </Modal>
    </>
  )
}
